import { render, staticRenderFns } from "./restriktionen-month-view.vue?vue&type=template&id=468e5a32&scoped=true"
import script from "./restriktionen-month-view.vue?vue&type=script&lang=js"
export * from "./restriktionen-month-view.vue?vue&type=script&lang=js"
import style0 from "./restriktionen-month-view.vue?vue&type=style&index=0&id=468e5a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468e5a32",
  null
  
)

export default component.exports